export const LANGS = ['engb', 'id', 'cn', 'th'];

export const LANG_ENUM = {
  ENGB: 'engb',
  ID: 'id',
  CN: 'cn',
  TH: 'th'
};
